import { Injectable } from '@angular/core';
import {
  getAuthCookie,
  persistAuthSession,
  setAuthCookie,
} from '../utils/auth-session.util';

const ACTIVE_WORKSPACE_STORAGE_KEY = 'customer_active_workspace_id';

/**
 * Workspace context for post-booking `/v1/bookings` calls (customer portal only).
 * Pre-booking discovery uses aggregated `/v1/customer/*` APIs.
 */
@Injectable({ providedIn: 'root' })
export class WorkspaceContextService {
  getActiveWorkspaceId(): string | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    return (
      localStorage.getItem(ACTIVE_WORKSPACE_STORAGE_KEY)?.trim() ||
      localStorage.getItem('workspace_id')?.trim() ||
      getAuthCookie('workspace_id')?.trim() ||
      null
    );
  }

  setActiveWorkspaceId(workspaceId: string | null | undefined): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    const value = workspaceId?.trim() ?? '';
    if (!value) {
      localStorage.removeItem(ACTIVE_WORKSPACE_STORAGE_KEY);
      return;
    }
    localStorage.setItem(ACTIVE_WORKSPACE_STORAGE_KEY, value);
    localStorage.setItem('workspace_id', value);
    setAuthCookie('workspace_id', value);
    const token =
      localStorage.getItem('brickhub_customer_auth') ||
      localStorage.getItem('accessToken') ||
      getAuthCookie('brickhub_customer_auth');
    if (token) {
      persistAuthSession({
        accessToken: token,
        workspaceId: value,
      });
    }
  }

  clearActiveWorkspaceId(): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    localStorage.removeItem(ACTIVE_WORKSPACE_STORAGE_KEY);
  }
}
